import { useAuth } from "@/hooks/auth";
import { useRoles } from "./useRoles";

interface MenuItem {
    permission?: string | string[];
    roles?: string | string[];
}

type AccessInput = MenuItem | string | string[];

export const useCanAccess = () => {
    const {roles = [], permissions = []} = useAuth();
    const { isSuperadmin } = useRoles();

    const canAccess = (input: AccessInput) => {
        if (isSuperadmin) return true;
        if (!input) return false;

        const item: MenuItem =
            typeof input === "string" || Array.isArray(input)
                ? { permission: input }
                : input;

        const hasPermission = item.permission
            ? Array.isArray(item.permission)
                ? item.permission.some(p => permissions.includes(p))
                : permissions.includes(item.permission)
            : false;

        const hasRole = item.roles
            ? Array.isArray(item.roles)
                ? item.roles.includes("All") || item.roles.some(r => roles.includes(r))
                : roles.includes(item.roles) || item.roles === "All"
            : false;

        return hasPermission || hasRole;
    };

    return canAccess;
};